<template>
	<div>
		<component :is="PlansComponent" />
	</div>
</template>

<script>
	import { get } from 'vuex-pathify'

	export default {
		name: 'Plans',
		computed: {
			...get('appSettings', [
				'landingSettings'
			]),
			PlansComponent() {
				return () => {
					switch (this.landingSettings?.siteTheme) {
						case 1:
							return import('./NafisTheme/Plans.vue')
						default:
							return import('./Default/Plans.vue')
					}
				}
			}
		},
		mounted() {

		},
		methods: {

		},
	}
</script>

<style lang="scss"></style>